import { render } from "./SearchInput.vue?vue&type=template&id=8b8081f2&ts=true"
import script from "./SearchInput.ts?vue&type=script&lang=ts"
export * from "./SearchInput.ts?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=8b8081f2&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__